import { createColumnHelper } from '@tanstack/react-table';
import { Typography } from '@mui/material';
import dayjs from 'dayjs';
import { Order } from '../../Models';
import { getTotalCosts, healthProviderTitle } from '../../utils/utils';
import { historyPriceFormatter } from '../../utils/formatters';
import StatePill from '../../Components/StatePill';

const columnHelper = createColumnHelper<Order>();

export const columns = [
    columnHelper.accessor('short_id', {
        id: 'short_id',
        header: 'Id',
        size: 50,
    }),
    columnHelper.accessor('creation_timestamp', {
        header: 'Fecha',
        cell: ({ getValue }) => (
            <div title={dayjs(getValue()).format('DD/MM/YYYY HH:mm')}>
                {dayjs(getValue()).format('DD/MM/YYYY')}
            </div>
        ),
        size: 150,
    }),
    columnHelper.accessor((row) => healthProviderTitle(row), {
        id: 'health_provider',
        header: 'OOSS',
        size: 150,
    }),
    columnHelper.accessor(
        (row) =>
            row.viewable_timeline.filter(
                (va) => va.pharmacy_id === row.assigned_pharmacy_id && va.is_referrer,
            ).length
                ? '⭐️'
                : '',
        {
            id: 'referred',
            header: '⭐️',
            size: 30,
        },
    ),
    columnHelper.accessor((row) => row.patient?.fullname || '', {
        id: 'fullname',
        header: 'Paciente',
        size: 250,
    }),
    columnHelper.accessor((row) => row.delivery_zone, {
        id: 'delivery_zone',
        header: 'Zona de envío',
        size: 150,
    }),
    columnHelper.accessor((row) => getTotalCosts(row.user_offer), {
        id: 'total_value',
        header: 'Monto de productos',
        cell: ({ getValue }) => (
            <div style={{ textAlign: 'right' }}>
                {historyPriceFormatter.format(getValue() ?? 0)}
            </div>
        ),
        size: 200,
    }),
    columnHelper.accessor('state', {
        header: 'Estado',
        cell: ({ getValue }) => <StatePill state={getValue()} />,
        size: 150,
    }),
    columnHelper.accessor(
        (row) => row.user_offer?.products?.map((p) => `x${p.quantity} ${p.name}`).join(',') || '',
        {
            id: 'products',
            header: 'Productos',
            cell: ({ getValue }) => (
                <Typography noWrap sx={{ textOverflow: 'ellipsis', maxWidth: 200 }}>
                    {getValue()}
                </Typography>
            ),
        },
    ),
];
